import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { User } from './models/user';
import { Perfil } from './models/perfil';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {}

  getUsers(cnpj: string): Observable<User[]> {
    if (cnpj === '') {
      return of([]);
    }

    return this.http.get<User[]>(`${environment.sso}/user-novo/${cnpj}`).pipe(catchError(err => of(err.error)));
  }

  getUser(uid: string): Observable<User> {
    if (uid === '') {
      return of();
    }

    return this.http.get<User>(`${environment.sso}/check-user-novo/${uid}`).pipe(catchError(err => of(err.error)));
  }

  getPerfis(): Observable<Perfil[]> {
    return this.http.get<Perfil[]>(`${environment.sso}/perfis`).pipe(catchError(err => of(err.error)));
  }

  addUser(cnpj: string, user: User): Observable<User> {
    if (cnpj === '') {
      return of();
    }

    return this.http
      .post<User>(`${environment.sso}/user-novo/${cnpj}`, user, this.httpOptions)
      .pipe(catchError(err => of(err.error)));
  }

  updateUser(cnpj: string, user: User): Observable<User> {
    if (cnpj === '') {
      return of();
    }

    return this.http
      .put<User>(`${environment.sso}/user-novo/${cnpj}`, user, this.httpOptions)
      .pipe(catchError(err => of(err.error)));
  }

  changeUserStatus(cnpj: string, uid: string): Observable<User> {
    if (cnpj === '') {
      return of();
    }

    return this.http
      .delete<User>(`${environment.sso}/user-novo/${cnpj}/${uid}`, this.httpOptions)
      .pipe(catchError(err => of(err.error)));
  }

  getUsersCollectors(cnpj: string): Observable<User[]> {
    if (cnpj === '') {
      return of([]);
    }

    return this.http.get<User[]>(`${environment.sso}/cobradores-novo/${cnpj}`).pipe(catchError(err => of(err.error)));
  }
}
